import UrlTemplate from "@xo-union/url-template";
export const SSI_URL_TEMPLATE = '/union-dist/{name}/{tag}/{path}';
export const QA_URL_TEMPLATE = 'https://qa.union.theknot.com/dist/v2/{name}/{tag}/{path}';
export const PROD_URL_TEMPLATE = 'https://union.theknot.com/dist/v2/{name}/{tag}/{path}';
const urlTemplateFromEnv = () => {
  const env = (() => {
    if (process.env.UNION_ASSETS_ENV) {
      if (process.env.UNION_ASSETS_ENV !== "qa" && process.env.UNION_ASSETS_ENV !== "production") {
        throw new Error(`Expected UNION_ASSETS_ENV to be 'qa' or 'production'.`);
      }
      console.warn('Using UNION_ASSETS_ENV could result in a misconfigured environment. It is best that you use UNION_DEPLOYMENT_ENV for all your Union services integrations.');
      return process.env.UNION_ASSETS_ENV;
    }
    if (process.env.UNION_DEPLOYMENT_ENV) {
      if (process.env.UNION_DEPLOYMENT_ENV !== "qa" && process.env.UNION_DEPLOYMENT_ENV !== "production") {
        throw new Error(`Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'.`);
      }
      return process.env.UNION_DEPLOYMENT_ENV;
    }
    if (false) {
      console.warn("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'. NODE_ENV fallback will be removed in a future version.");
      return process.env.NODE_ENV === 'production' ? 'production' : 'qa';
    }
    throw new Error("Expected UNION_DEPLOYMENT_ENV to be either 'qa' or 'production'.");
  })();
  if (env === 'qa') {
    return QA_URL_TEMPLATE;
  }
  return PROD_URL_TEMPLATE;
};
export const getUrl = _ref => {
  let {
    urlTemplate = process.env.UNION_DISTRIBUTION_URL_TEMPLATE || urlTemplateFromEnv(),
    params
  } = _ref;
  return new UrlTemplate(urlTemplate, params);
};
export const getSSIUrl = _ref2 => {
  let {
    urlTemplate = process.env.UNION_SSI_URL_TEMPLATE || SSI_URL_TEMPLATE,
    params
  } = _ref2;
  return new UrlTemplate(urlTemplate, params);
};